export default __webpack_public_path__ + "static/media/seth.881807e6.png";